import { API } from '@/config';
export default class ClockService {
  getEpochTime() {
    return fetch(`${API.BASE_URL}/api/account/servertime`).then((response) =>
      response.json()
    );
  }
}
